<template>
  <section class="page cart">
    <cart-table
      :goodsList="orderGoods"
      type="preOrder"
      :totalPrice="totalPrice"
      v-on:handlePay="handlePay"
    ></cart-table>
    <div class="ou-card-bottom-gap"></div>
    <el-dialog
      title="付款"
      :visible.sync="modalShow"
      width="500px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :before-close="beforePayModalClose"
      class="ou-modal pay-modal"
    >
      <div class="protocol-scroll-wrap">
        <div class="info-row">
          支付金额：<span class="price-span">{{ totalPrice }}</span>
        </div>
        <div class="info-row">支付方式：</div>
        <div class="pay-way-wrap">
          <div
            class="pay-box"
            @click="selectWay('wx')"
            :class="[selectedWay === 'wx' ? 'active' : '']"
          >
            <div class="box-wrap">
              <el-image
                :src="require('@/assets/icon/wxpay.png')"
                fit="contain"
              ></el-image>
            </div>
            <el-image
              v-show="selectedWay === 'wx'"
              class="select-flag"
              :src="require('@/assets/icon/btn-pay-corner.png')"
              fit="contain"
            ></el-image>
          </div>
          <div
            class="pay-box"
            @click="selectWay('ali')"
            :class="[selectedWay === 'ali' ? 'active' : '']"
          >
            <div class="box-wrap">
              <el-image
                :src="require('@/assets/icon/alipay.png')"
                fit="contain"
              ></el-image>
            </div>
            <el-image
              v-show="selectedWay === 'ali'"
              class="select-flag"
              :src="require('@/assets/icon/btn-pay-corner.png')"
              fit="contain"
            ></el-image>
          </div>
        </div>
        <div v-show="selectedWay !== ''">
          <div class="info-row">扫码支付：</div>
          <div class="qrcode-box">
            <div id="qrcode2" v-show="selectedWay === 'wx'"></div>
            <div id="qrcode" v-show="selectedWay === 'ali'"></div>
            <div class="qrcode-tips">
              {{
                selectedWay === "wx"
                  ? "打开手机微信扫码支付"
                  : "打开手机支付宝扫码支付"
              }}
            </div>
            <div
              v-show="selectedWay === 'wx'"
              @click="refresh"
              class="qrcode-tips"
            >
              刷新
            </div>
            <div
              v-show="selectedWay === 'ali'"
              @click="refresh2"
              class="qrcode-tips"
            >
              刷新
            </div>
          </div>
        </div>
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="mockPay">一键支付</el-button>
      </div> -->
    </el-dialog>
  </section>
</template>

<script>
import QRCode from "qrcodejs2";
import { mapGetters, mapActions } from "vuex";
import { aliCode, wxCode, aliOrderQuery, wxOrderQuery } from "@/api/cart/cart";
import { goodsInfoDetail } from "@/api/bookstore/bookstore";
import {
  specialDetailInfo,
  listResource,
  listEvaluate,
} from "@/api/special/special";
import {
  apiGetOrderDetail,
  apiAfterPay,
  apiCreateOrder,
  apiCreateSubjectOrder,
  apiCheckIsCreated,
} from "@/api/user/order";
import CartTable from "./components/CartTable";

export default {
  name: "preOrder",
  components: { CartTable },
  data() {
    return {
      orderNumber: null,
      codeUrl: null,
      codeUrl2: null,
      orderGoods: [],
      subjectInfo: {},
      modalShow: false,
      selectedWay: "wx",
      from: "",
      orderId: "",
      timer1: null,
      timer2: null,
    };
  },
  watch: {},
  computed: {
    ...mapGetters([
      "getCartNum",
      "getCheckNum",
      "getTotalPrice",
      "getIsAllCheck",
      "getCheckGoods",
      "userId",
    ]),
    totalPrice() {
      if (this.$route.query.from === "special") {
        return this.subjectInfo.sellingPrice;
      }
      let total = 0;
      this.orderGoods.forEach((item) => {
        total += Number(item.realPrice);
      });
      return total;
    },
  },
  activated() {
    console.log("路由", this.$route);
    // 根据不同来源作出不同行为
    // 书城: 获取商品详情； 专题: 获取专题下商品详情； 购物车: 获取vuex管理的已选商品列表；
    let { from, id } = this.$route.query;
    if (from === "bookstore") {
      this.getGoodsDetail(id);
    } else if (from === "cart") {
      this.orderGoods = this.getCheckGoods;
    } else if (from === "special") {
      this.from = "special";
      this.getSubjectInfo(id);
    }
  },
  created() {},
  mounted() {},
  beforeDestroy() {
    this.timer1 && clearInterval(this.timer1);
    this.timer2 && clearInterval(this.timer2);
  },
  methods: {
    // 获取商品详情
    getGoodsDetail(id) {
      goodsInfoDetail(id).then((res) => {
        let { realPrice, prices, goodsTitle, goodsId } = res.data.goods,
          covers = res.data.coverFiles;
        let list = [
          {
            realPrice,
            prices,
            goodsTitle,
            goodsId,
            cover: covers && covers.length ? covers[0].fullUrl : "",
          },
        ];
        this.orderGoods = list;
      });
    },
    getSubjectInfo(id) {
      specialDetailInfo(id).then((res) => {
        this.subjectInfo = res.data;
        let {
          picFile: cover,
          subjectName: goodsTitle,
          price: prices,
          sellingPrice: realPrice,
          id: subjectId,
        } = res.data;
        this.orderGoods = [
          { cover, goodsTitle, prices, realPrice, subjectId, isSubject: true },
        ];
      });
    },
    async handlePay() {
      // 此处先下单
      let { from, id: subjectId } = this.$route.query;
      let list = [...this.orderGoods];
      let ids = [],
        payment = 0;
      if (from === "special") {
        payment = this.subjectInfo.sellingPrice;
        let data = { subjectId, userId: this.userId, payment };
        apiCreateSubjectOrder(data).then((res) => {
          if (!(res.data && res.data.id)) {
            this.$message.error("创建订单失败，请稍后重试");
            return;
          }
          if (from === "cart") {
            this.$store.dispatch("GetShoppingCart");
          }
          if (Number(payment) === 0) {
            // apiAfterPay({ id: res.data.id }).then(() => {
            this.$message.success("购买成功");
            setTimeout(() => {
              this.$router.push("/user/myOrder");
            }, 800);
            // });
            return;
          }
          this.orderId = res.data.id;
          this.modalShow = true;
          this.orderNumber = res.data.orderNumber;
          this.selectedWay === "wx" && this.getWxCode();
          this.selectedWay === "ali" && this.getAliCode();
          this.selectedWay === "wx" && this.wxOrderState();
          this.selectedWay === "ali" && this.aliOrderState();
        });
      } else {
        //待创建来源为书城或购物车
        list.forEach((item) => {
          ids.push(item.goodsId);
          payment += Number(item.realPrice);
        });
        apiCreateOrder({
          goodsIds: ids.join(","),
          userId: this.userId,
          payment,
          sourceType: "web",
        }).then((res) => {
          if (!(res.data && res.data.id)) {
            this.$message.error("创建订单失败，请稍后重试");
            return;
          }
          if (from === "cart") {
            this.$store.dispatch("GetShoppingCart");
          }
          if (Number(payment) === 0) {
            // apiAfterPay({ id: res.data.id }).then(() => {
            this.$message.success("购买成功");
            setTimeout(() => {
              this.$router.push("/user/myOrder");
            }, 800);
            // });
            return;
          }
          this.modalShow = true;
          this.orderNumber = res.data.orderNumber;
          this.selectedWay === "wx" && this.getWxCode();
          this.selectedWay === "ali" && this.getAliCode();
          this.selectedWay === "wx" && this.wxOrderState();
          this.selectedWay === "ali" && this.aliOrderState();
          this.orderId = res.data.id;
        });
      }
    },
    // mockPay() {
    //   if (!this.orderId) {
    //     this.$message.error(
    //       "获取订单凭据出错，请前往【个人中心】-【我的订单】继续支付"
    //     );
    //     return;
    //   }
    //   apiAfterPay({ id: this.orderId }).then(() => {
    //     this.modalShow = false;
    //     this.$message.success("订单支付成功");
    //     this.timer1 && clearInterval(this.timer1);
    //     this.timer2 && clearInterval(this.timer2);
    //     setTimeout(() => {
    //       this.$router.push("/user/myOrder");
    //     }, 800);
    //   });
    // },
    selectWay(value) {
      if (value === "wx") {
        // this.selectedWay = this.selectedWay !== 'wx' ? 'wx' : ''
        this.selectedWay = "wx";
        this.getWxCode();
        clearInterval(this.timer2);
        clearInterval(this.timer1);
        this.wxOrderState();
      } else if (value === "ali") {
        // this.selectedWay = this.selectedWay !== 'ali' ? 'ali' : ''
        this.selectedWay = "ali";
        this.getAliCode();
        clearInterval(this.timer1);
        clearInterval(this.timer2);
        this.aliOrderState();
      }
    },
    beforePayModalClose(close) {
      this.$confirm(
        `若关闭当前窗口后续可从【我的订单】完成支付，确定暂不支付吗？`,
        "系统提示",
        {
          type: "warning",
        }
      ).then(() => {
        this.timer1 && clearInterval(this.timer1);
        this.timer2 && clearInterval(this.timer2);
        setTimeout(() => {
          this.$router.push("/user/myOrder");
        }, 500);
        close();
      });
    },
    getWxCode() {
      // 获取微信二维码
      wxCode(this.orderNumber).then((res) => {
        let code = res.data ? res.data.qrCode : null;
        if (!code) {
          this.$message.error("获取支付二维码失败");
          const dom = document.getElementById("qrcode2");
          if (dom) dom.innerHTML = "";
          return;
        }
        this.codeUrl2 = code;
        this.$nextTick(() => {
          this.createQrcode2();
        });
      });
    },
    getAliCode() {
      // 获取支付宝二维码
      aliCode(this.orderNumber).then((res) => {
        let code = res.data ? res.data.qrCode : null;
        if (!code) {
          this.$message.error("获取支付二维码失败");
          const dom = document.getElementById("qrcode");
          if (dom) dom.innerHTML = "";
          return;
        }
        this.codeUrl = code;
        this.$nextTick(() => {
          this.createQrcode();
        });
      });
    },
    createQrcode() {
      // 若存在，先删除二维码
      const dom = document.getElementById("qrcode");
      if (dom) dom.innerHTML = "";
      // 这里会自动去取模版中的id为qrcode的
      const qrcode = new QRCode("qrcode", {
        width: 150, // 宽
        height: 150, // 高
        text: this.codeUrl, // 链接地址
      });
      return qrcode;
    },
    createQrcode2() {
      // 若存在，先删除二维码
      const dom = document.getElementById("qrcode2");
      if (dom) dom.innerHTML = "";
      // 这里会自动去取模版中的id为qrcode的
      const qrcode = new QRCode("qrcode2", {
        width: 150, // 宽
        height: 150, // 高
        text: this.codeUrl2, // 链接地址
      });
      return qrcode;
    },
    //刷新二维码
    refresh() {
      $(".qrcode").html(""); //把之前的置为空
      this.getWxCode();
    },
    //刷新二维码
    refresh2() {
      $(".qrcode").html(""); //把之前的置为空
      this.getAliCode();
    },
    // 轮询微信订单状态
    wxOrderState() {
      this.timer1 = setInterval(() => {
        wxOrderQuery(this.orderNumber, "web").then((res) => {
          if (res.code == 200) {
            // apiAfterPay({ id: this.orderId }).then(() => {
            clearInterval(this.timer1);
            this.modalShow = false;
            this.$message.success("订单支付成功");
            setTimeout(() => {
              this.$router.replace("/user/myOrder");
            }, 800);
            // });
          }
        });
      }, 3000);
    },
    // 轮询支付宝订单状态
    aliOrderState() {
      this.timer2 = setInterval(() => {
        aliOrderQuery(this.orderNumber).then((res) => {
          if (res.code == 200) {
            // apiAfterPay({ id: this.orderId }).then(() => {
            clearInterval(this.timer2);
            this.modalShow = false;
            this.$message.success("订单支付成功");
            setTimeout(() => {
              this.$router.replace("/user/myOrder");
            }, 800);
            // });
          }
        });
      }, 3000);
    },
  },
};
</script>

<style scoped lang="scss">
.info-row {
  display: flex;
  align-items: center;
  padding: 8px;
}
.price-span {
  font-size: 18px;
  font-weight: 400;
  color: #ff5353;
  margin-left: 16px;
  &::before {
    content: "¥";
  }
}
.ou-modal.pay-modal ::v-deep {
  .el-dialog__body {
    padding-bottom: 0;
  }
}
.pay-way-wrap {
  padding: 28px 20px 34px;
  display: flex;
  justify-content: space-between;
  .pay-box {
    width: 180px;
    height: 56px;
    position: relative;
    box-sizing: border-box;
    border: 1px solid #f2f2f2;
    cursor: pointer;
    .box-wrap {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &.active {
      border: 1px solid #2e9adb;
    }
    .select-flag {
      position: absolute;
      bottom: -1px;
      right: 0;
    }
  }
}

.qrcode-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 20px 48px;
  flex-direction: column;
  .qrcode-img {
    width: 150px;
    height: 150px;
  }
  .qrcode-tips {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    margin-top: 20px;
    cursor: pointer;
  }
  .qrcode-tips:last-of-type {
    cursor: pointer;
  }
}

.dialog-footer ::v-deep {
  text-align: center;
  .el-button {
    width: 200px;
    font-size: 16px;
    padding: 8px 20px;
    background-color: #2e9adb;
    border-radius: 6px;
  }
}
</style>
